import React, {Component} from 'react';
import {addClassToBody} from "../../utils/utils";
import {Link} from "react-router-dom";
import validator from "validator";
import classnames from "classnames";
import {connect} from "react-redux";
import {login} from "../../store/actions/auth";
import PropTypes from "prop-types";
import {setErrors} from "../../store/actions/error";

class Login extends Component {
  constructor(props) {
    super(props);
    addClassToBody('auth-page');
    this.handleUserInput = this.handleUserInput.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
    this.state = {
      email: {
        value: '',
        isValid: false,
        errorMessage: '',
        touched: false
      },
      password: {
        value: '',
        isValid: false,
        errorMessage: '',
        touched: false
      },
      formValid: false
    };
  }

  componentWillMount() {
    if (this.props.auth.isAuthenticated) {
      this.props.history.push('/dashboard');
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors && nextProps.errors.status === 412) {
      this.setState({
        password: {
          ...this.state.password,
          isValid: false,
          errorMessage: 'Wrong email / password.'
        }
      });
    }
  }

  componentWillUnmount() {
    this.props.setErrors()
  }

  handleUserInput(ev) {
    const name = ev.target.name;
    const value = ev.target.value;

    this.setState({
      [name]: {
        ...this.state[name],
        value
      }
    }, () => this.validateField(name, value));
  }

  validateField(fieldName, value) {
    let emailValid = this.state.email.isValid;
    let passwordValid = this.state.password.isValid;
    let emailErrorMessage = this.state.email.errorMessage;
    let passwordErrorMessage = this.state.password.errorMessage;

    switch (fieldName) {
      case 'email':
        emailValid = validator.isEmail(value);
        emailErrorMessage = 'Entered email address is wrong.';
        break;
      case 'password':
        passwordValid = value.match(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/);
        passwordErrorMessage = 'Password must be at least 8 characters long containing at least one number and a letter.';
        break;
      default:
        break;
    }

    this.setState({
      [fieldName]: {
        ...this.state[fieldName],
        isValid: fieldName === 'email' ? emailValid : passwordValid,
        errorMessage: fieldName === 'email' ? emailErrorMessage : passwordErrorMessage
      }
    }, this.validateForm);
  }

  validateForm() {
    this.setState({
      formValid: this.state.email.isValid && this.state.password.isValid
    });
  }

  handleInputBlur(ev) {
    const name = ev.target.name;

    this.setState({
      [name]: {
        ...this.state[name],
        touched: !!ev.target.value
      }
    });
  }

  onSubmit(ev) {
    ev.preventDefault();
    if (this.state.formValid) {
      const userData = {
        password: this.state.password.value,
        username: this.state.email.value
      };

      this.props.login(userData, this.props.history);
    }
  }

  render() {
    const {email, password} = this.state;

    return (
        <section className="auth">
          <div className="container">
            <div className="row justify-content-center">
              <form className="col-md-6 col-11 auth-form" onSubmit={this.onSubmit.bind(this)}>
                <div className="form-title">
                  <h1>Login</h1>
                </div>
                <div className={classnames('form-group', {'invalid': !email.isValid && email.touched})}>
                  <input name="email" type="email" className="form-control" placeholder="Email address *"
                         value={email.value} onChange={this.handleUserInput} onBlur={this.handleInputBlur}/>
                  {!email.isValid && email.touched && (
                      <p className="error-msg">{email.errorMessage}</p>)}
                </div>
                <div className={classnames('form-group mb-4', {'invalid': !password.isValid && password.touched})}>
                  <input name="password" type="password" className="form-control" placeholder="Password *"
                         value={password.value} onChange={this.handleUserInput} onBlur={this.handleInputBlur}/>
                  {!password.isValid && password.touched && (
                      <p className="error-msg">{password.errorMessage}</p>)}
                </div>
                <div className="form-group text-center mb-4">
                  <button type="submit" className="btn btn-lg btn-primary" disabled={!this.state.formValid}>
                    Login
                  </button>
                </div>
                <ul className="form-links text-center">
                  <li><Link to="/forgot-password">Forgot password</Link></li>
                </ul>
              </form>
            </div>
          </div>
        </section>
    );
  }
}

Login.propTypes = {
  login: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.any,
  setErrors: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.error.errors
});

const mapDispatchToProps = dispatch => ({
  login: (userData, history) => dispatch(login(userData, history)),
  setErrors: () => dispatch(setErrors(null))
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/Login/Login.jsx